import * as Yup from 'yup';
import { RedirectParams } from '../../../../../../shared/types/redirectParams';

export const initialValues: RedirectParams = {
    code: '',
    class: '',
    name: '',
    extra: '',
    active: true,
};

export const validationSchema = () =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        extra: Yup.string().required('La descrición es obligatoria'),
    });
